import { render } from "./KidsHeroSlider.vue?vue&type=template&id=297f8040&scoped=true"
import script from "./KidsHeroSlider.vue?vue&type=script&lang=js"
export * from "./KidsHeroSlider.vue?vue&type=script&lang=js"

import "./KidsHeroSlider.vue?vue&type=style&index=0&id=297f8040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297f8040"]])

export default __exports__